import React, { useLayoutEffect, useState } from 'react';

import { getToastDynamicStyles } from '~/components/toasts-layout/utils';
import { Toast } from '~/stores/use-toasts/useToasts';

import styles from './ToastsLayout.module.scss';

export interface DisplayToast {
  toast: Toast;
  exiting: boolean;
  displayIndex: number;
}

export interface ToastItemProps {
  displayToast: DisplayToast;
  offsetY: number;
}

export const ToastItem = React.forwardRef<HTMLDivElement, ToastItemProps>(
  ({ displayToast, offsetY }, ref) => {
    const { toast, exiting } = displayToast;
    const [enterFrom, setEnterFrom] = useState(!exiting);

    useLayoutEffect(() => {
      if (exiting || !enterFrom) return;
      const raf = requestAnimationFrame(() => setEnterFrom(false));
      return () => cancelAnimationFrame(raf);
    }, [enterFrom, exiting]);

    const dynamicStyle = getToastDynamicStyles({
      position: toast.position,
      offsetY,
      enterFrom,
      exiting,
    });

    return (
      <div
        ref={ref}
        className={styles.toast}
        style={dynamicStyle}
        data-testid="global-toast"
      >
        {toast.content}
      </div>
    );
  }
);
